// hooks
import { FormulaType } from '../../constants/formulaType';

// helpers
import confirm from '../../helpers/confirm';

import { FormulaTypesData } from '../../models/formula.model';
// models
import { NotifyDeveloperRequest } from '../../models/notify-developer.model';

import useNotifyDeveloper from '../common/useNotifyDeveloper';

export default function useHandleIntegrationRequest(formulaType: FormulaType) {
    const notify = useNotifyDeveloper();

    const handleIntegrationRequest = async () => {
        const confirmed = await confirm(
            `Your ${FormulaTypesData[formulaType].title} provider is not yet configured.`,
            undefined,
            `To start sending ${FormulaTypesData[formulaType].title} messages, send us an integration request.`,
            'Cancel',
            'Send integration request',
            true,
            false,
        );
        if (confirmed) {
            notify.mutate(
                {
                    request_code: NotifyDeveloperRequest.ChannelIntegration,
                    metadata: {
                        channel: formulaType,
                    },
                },
                {
                    onSuccess: async () => {
                        await confirm(
                            `${FormulaTypesData[formulaType].title} integration request sent`,
                            'success',
                            'Aampe team will come back to you when integration is complete',
                            undefined,
                            'Close',
                            false,
                            false,
                            true,
                        );
                    },
                },
            );
        }
    };
    return {
        handleIntegrationRequest,
        requestSent: notify.isSuccess,
        requestLoading: notify.isPending,
    };
}
